import toast from 'react-hot-toast';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { sendErrorReport } from '../../shared/utilities/sendErrorReport';

import * as actions from './actions';
import * as api from './api';

import { NormalizedPreTripReview, RemovePreTripReviewAction } from './types';
import { removePreTripReviewFromCache } from './cache-utils';

function* getPreTripReviewsFlow(): SagaIterator {
    try {
        const apiResponse: NormalizedPreTripReview = yield call(api.fetchPreTripReviews);
        yield put(actions.getPreTripReviewsSuccess(apiResponse));
    } catch (e) {
        yield put(actions.getPreTripReviewsFailure((e as Error).message));
        sendErrorReport(e as Error);
    }
}

function* removePreTripReviewFlow({ dossierId }: RemovePreTripReviewAction) {
    try {
        yield call(api.patchRemovePreTripReview, dossierId);

        // TODO: Move that to mutation cache update once preTripReview gets migrated to react-query
        removePreTripReviewFromCache(dossierId);
        yield put(actions.removePreTripReviewSuccess());
        toast.success('dossier.pre_trip_review.notifications.success');
    } catch (e) {
        yield put(actions.removePreTripReviewFailure((e as Error).message));
        toast.error('dossier.pre_trip_review.notifications.error');
        sendErrorReport(e as Error);
    }
}

export function* getPreTripReviewsRequestWatcher(): SagaIterator {
    yield takeLatest(actions.fetchPreTripReviewsRequestAction, getPreTripReviewsFlow);
    yield takeLatest(actions.removePreTripReviewAction, removePreTripReviewFlow);
}
